import { authService } from '@/services';
import { Preferences } from '@capacitor/preferences';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        userId: 0,
        userType: 0,
    }),
    getters: {
        async getUserId() {
            const user = await Preferences.get({ key: 'auth_user' });

            if (!user.value) return 0;

            const { userId } = JSON.parse(user.value);

            return userId || 0;
        },
        async getUserName() {
            const user = await Preferences.get({ key: 'auth_user' });

            if (!user.value) return '';

            const { firstName } = JSON.parse(user.value);

            return firstName || '';
        },
        async getLoyaltyMemberId() {
            const user = await Preferences.get({ key: 'auth_user' });

            if (!user.value) return '';

            const { loyaltyMemberId } = JSON.parse(user.value);

            return loyaltyMemberId || '';
        },
        async getPointsBalance() {
            const user = await Preferences.get({ key: 'auth_user' });

            if (!user.value) return 0;

            const { pointsBalance } = JSON.parse(user.value);

            return pointsBalance || 0;
        },
        async getActiveMembership() {
            const user = await Preferences.get({ key: 'auth_user' });

            if (!user.value) return false;

            const { activeMembership } = JSON.parse(user.value);

            return activeMembership || false;
        },
        async getReferralCode() {
            const user = await Preferences.get({ key: 'auth_user' });
            if (!user.value) return '';

            const { hasReferralCode } = JSON.parse(user.value);

            return hasReferralCode || '';
        },
    },
    actions: {
        cleanUserData() {
            this.userId = 0;
            this.userType = 0;
        },
        async setLoyaltyMemberId(id: string) {
            const user = await Preferences.get({ key: 'auth_user' });
            if (!user.value) return;
            const userData = JSON.parse(user.value);
            userData.loyaltyMemberId = id;
            await Preferences.set({ key: 'auth_user', value: JSON.stringify(userData) });
        },
        sendRecoveryPasswordEmail(email) {
            return authService.forgotPassword(email);
        },
    },
});
